module.exports = __webpack_public_path__ + "static/media/CitrusStage0.056b4be4.PNG";